import { EventNames } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { Snackbar } from '../../../../ReactComponents/Snackbar/Snackbar';
import { FirstFavouriteModalProps } from './FirstFavouriteModalProps.csharp';

export const showFirstFavouriteModal = () => {
    const event = new CustomEvent(EventNames.AddedFirstFavourite);
    window.dispatchEvent(event);
};

export const FirstFavouriteModal = ({ favouritesPageUrl }: FirstFavouriteModalProps) => {
    const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);

    useEffect(() => {
        window.addEventListener(EventNames.AddedFirstFavourite, showSnackbar);

        return () => {
            window.removeEventListener(EventNames.AddedFirstFavourite, showSnackbar);
        };
    }, []);

    const showSnackbar = () => setIsSnackbarVisible(true);
    const closeSnackbar = () => setIsSnackbarVisible(false);

    return (
        <Snackbar
            className="FirstFavouriteModal"
            isVisible={isSnackbarVisible}
            heading={getTranslation(keys['favourites.firstFavouriteHeading'])}
            text={getTranslation(keys['favourites.firstFavouriteContent'])}
            linkUrl={favouritesPageUrl}
            linkText={getTranslation(keys['favourites.goToFavourites'])}
            onClose={closeSnackbar}
            autoHide
        />
    );
};
